import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass'
import { values } from 'lodash'
// import { find, assign } from 'lodash'
// import geocoder from 'google-geocoder'
// const geo = geocoder({
//   key: 'AIzaSyDFXVm2WBn4Rp9gasTbvyHINk3DMGmN-1Q',
// })

import threeEntryPoint from './threejs/threeEntryPoint'

const GlobeWrapper = styled.div`
  box-sizing: border-box;
  width: ${props => (props.size ? '100vw' : '12rem')};
  height: ${props => (props.size ? '100vh' : '12rem')};
  position: ${props => (props.size ? 'static' : 'sticky')};
  margin: ${props => (props.size ? '' : '2rem')};
  top: 0;
  @media screen and (max-width: 60rem) {
    ${props => (!props.size ? `display: none;` : `height: 100vw`)};
  }
`

export default class Globe extends Component {
  constructor(props) {
    super(props)
    console.log(props)
  }

  componentWillReceiveProps() {
    // threeEntryPoint.test()
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      if (!localStorage.notFirstVisit) {
        fetch('/.netlify/functions/hello')
        localStorage.notFirstVisit = true
      }
    }
    var visitors = []
    this.props.visitorCoords.map(({ node }) => {
      visitors.push(node.Lat)
      visitors.push(node.Lng)
      visitors.push(node.Amount)
    })
    threeEntryPoint(this.threeRootElement, this.props.coords, visitors)
  }

  render() {
    return (
      <Flex justify="center">
        <GlobeWrapper size={this.props.isHome}>
          <div
            style={{ width: '100%', height: '100%' }}
            ref={element => (this.threeRootElement = element)}
          />
        </GlobeWrapper>
      </Flex>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Globe.js